import { useTranslation } from 'react-i18next';
import { DialogContent, Grid, Stack, Typography } from '@mui/material';
import RetryInstructions from './RetryInstructions';
import IgnoreInstructions from './IgnoreInstructions';

function DeviceDenied({ device, reason }) {
  const { t } = useTranslation();

  return (
    <DialogContent>
      <Stack spacing={2}>
        <Grid item>
          <Typography fontSize="14px">
            {t(
              `It appears as though the website's access to the ${device} is ${reason}.`
            )}{' '}
            {t(
              `Go to your browser's settings and allow access to the ${device}.`
            )}
            <RetryInstructions />
          </Typography>
        </Grid>
        <IgnoreInstructions device={device} />
      </Stack>
    </DialogContent>
  );
}

export default DeviceDenied;
